module.exports = __webpack_public_path__ + "static/media/logo-cropped.081f73cc.png";